import { render } from "./MultiselectDropdown.vue?vue&type=template&id=1f466668&scoped=true"
import script from "./MultiselectDropdown.vue?vue&type=script&lang=js"
export * from "./MultiselectDropdown.vue?vue&type=script&lang=js"

import "./MultiselectDropdown.vue?vue&type=style&index=0&id=1f466668&scoped=true&lang=css"

import exportComponent from "../../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f466668"]])

export default __exports__